// Frontend/src/component/demodashboard/DemoDashboard.jsx
import React, { useState } from "react";
import styles from "./demodashboard.module.css";

import UseCases from "./usecases/usecases";
import FlowDesigners from "./flowdesigners/flowdesigners";
import TestCallPlayground from "./testcallplayground/testcallplayground";

const DemoDashboard = () => {
  const [activeTab, setActiveTab] = useState("use-case");
  const [hoverTab, setHoverTab] = useState(null);

  const renderActiveTab = () => {
    switch (activeTab) {
      case "use-case":
        return <UseCases />;
      case "flow-designers":
        return <FlowDesigners />;
      case "test-call":
      default:
        return <TestCallPlayground />;
    }
  };

  return (
    <div className={styles.wrapper}>
      {/* Tech Background Elements */}
      <div className={styles.techBgElements}>
        <div className={styles.binaryGrid}></div>
        <div className={styles.glowOrb}></div>
        <div className={styles.circuitLines}></div>
      </div>

      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerTitle}>
          <h1 className={styles.title}>AI Demo Dashboard</h1>
          {/* <span className={styles.titleBadge}>BETA</span> */}
        </div>
        <p className={styles.headerSubtitle}>
          Experience the power of AI-MEBOT's advanced features
        </p>
      </div>

      {/* Tabs */}
      <div className={styles.tabsContainer}>
        <div className={styles.tabs}>
          <button
            className={`${styles.tab} ${
              activeTab === "use-case" ? styles.activeTab : ""
            }`}
            onClick={() => setActiveTab("use-case")}
            onMouseEnter={() => setHoverTab("use-case")}
            onMouseLeave={() => setHoverTab(null)}
          >
            {/* <span className={styles.tabIcon}>🎯</span> */}
            <span className={styles.tabText}>Use Case</span>
            <span className={styles.tabGlow}></span>
            {activeTab === "use-case" && (
              <div className={styles.activeIndicator}></div>
            )}
          </button>

          <button
            className={`${styles.tab} ${
              activeTab === "flow-designers" ? styles.activeTab : ""
            }`}
            onClick={() => setActiveTab("flow-designers")}
            onMouseEnter={() => setHoverTab("flow-designers")}
            onMouseLeave={() => setHoverTab(null)}
          >
            {/* <span className={styles.tabIcon}>🌀</span> */}
            <span className={styles.tabText}>Flow Designers</span>
            <span className={styles.tabGlow}></span>
            {activeTab === "flow-designers" && (
              <div className={styles.activeIndicator}></div>
            )}
          </button>

          <button
            className={`${styles.tab} ${
              activeTab === "test-call" ? styles.activeTab : ""
            }`}
            onClick={() => setActiveTab("test-call")}
            onMouseEnter={() => setHoverTab("test-call")}
            onMouseLeave={() => setHoverTab(null)}
          >
            {/* <span className={styles.tabIcon}>🧪</span> */}
            <span className={styles.tabText}>Test Call</span>
            <span className={styles.tabGlow}></span>
            {activeTab === "test-call" && (
              <div className={styles.activeIndicator}></div>
            )}
          </button>
        </div>
        <div className={styles.tabUnderline}></div>
      </div>

      {/* Content */}
      <div className={styles.contentArea}>
        {/* Content Header */}
        <div className={styles.contentHeader}>
          <h2 className={styles.contentTitle}>
            {activeTab === "use-case" && "AI Use Cases"}
            {activeTab === "flow-designers" && "Flow Designer Studio"}
            {activeTab === "test-call" && "AI Test Playground"}
          </h2>
          <div className={styles.statusIndicator}>
            <span className={styles.statusDot}></span>
            <span className={styles.statusText}>Live</span>
          </div>
        </div>
        
        {/* Tab Content */}
        <div className={styles.tabContent}>
          {renderActiveTab()}
        </div>
      </div>

      {/* Footer */}
      <div className={styles.footer}>
        <div className={styles.footerLeft}>
          <span className={styles.footerIcon}>ⓘ</span>
          <p>This is a simplified demo. Full editing is available in the platform.</p>
        </div>
        {/* <div className={styles.footerRight}>
          <p>Ready to build real agents?</p>
          <button className={styles.upgradeBtn}>
            <span className={styles.btnIcon}></span>
            Upgrade Now
            <div className={styles.btnGlow}></div>
          </button>
        </div> */}
      </div>

      {/* Bottom Tech Elements */}
      <div className={styles.bottomTech}>
        <div className={styles.dataFlow}></div>
        <div className={styles.connectionDots}>
          {[...Array(8)].map((_, i) => (
            <div key={i} className={styles.connectionDot}></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DemoDashboard;